export default "__VITE_ASSET__DGPxyOTP__"